import React, { useEffect, useState } from "react";
import { ImagePlus, Save } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/lib/AuthContext";
import { base44 } from "@/api/base44Client";
import { isAtLeast } from "@/lib/roles";

import { safeLocalStorage } from '@/lib/browserStorage';
export default function CompanyDetailsSection() {
  const { effectiveRole, user } = useAuth();
  const [name, setName] = useState("");
  const [logo, setLogo] = useState("");
  useEffect(() => {
    if (!isAtLeast(effectiveRole, "owner")) return;
    setName(user?.organisation_name || user?.organization_name || user?.organisation || user?.company_name || safeLocalStorage.getItem("drilllog_company_name") || "");
    setLogo(safeLocalStorage.getItem("drilllog_company_logo") || "");
  }, [effectiveRole, user]);
  if (!isAtLeast(effectiveRole, "owner")) return null;
  const chooseLogo = async (e) => {
    const file = e.target.files?.[0]; if (!file) return;
    const result = await base44.integrations.Core.UploadFile({ file });
    setLogo(result.file_url);
  };
  const save = async () => {
    if (name.trim()) safeLocalStorage.setItem("drilllog_company_name", name.trim());
    if (logo) safeLocalStorage.setItem("drilllog_company_logo", logo); else safeLocalStorage.removeItem("drilllog_company_logo");
    if (user?.id) await base44.entities.User.update(user.id, { company_logo: logo || null });
  };
  return <section className="rounded-xl border bg-white p-4 shadow-sm dark:bg-slate-900"><div className="space-y-4"><div><h2 className="font-semibold">Company Details</h2><p className="text-sm text-muted-foreground">Company name follows the organisation attached to the user licence. The logo is shown on the dashboard and exported PDFs.</p></div><div><Label>Licensed organisation</Label><Input value={name} readOnly className="rounded-xl bg-slate-50 dark:bg-slate-800" /><p className="text-xs text-slate-500 mt-1">Organisation name is taken from the licensed user profile and cannot be changed here.</p></div><div><Label>Company logo</Label><div className="flex items-center gap-3 mt-2"><label className="inline-flex items-center gap-2 rounded-xl border px-3 py-2 cursor-pointer"><ImagePlus className="w-4 h-4"/> Upload<input type="file" accept="image/*" className="hidden" onChange={chooseLogo}/></label>{logo && <img src={logo} alt="Company logo" className="h-12 max-w-48 object-contain"/>}</div></div><Button onClick={save} className="rounded-xl gap-2"><Save className="w-4 h-4"/> Save Company Details</Button></div></section>;
}
